/**
 * Investment Timeline Section frontend: auto-cycling active step animation.
 */
( function () {
	'use strict';

	const BLOCK_SELECTOR =
		'.wp-block-alteia-investment-timeline-section.alteia-investment-timeline-section';
	const VISIBILITY_THRESHOLD = 0.25;
	// Matches the block's desktop layout breakpoint (min-width: 992px).
	const DESKTOP_MIN_WIDTH = 992;

	/*
	 * Step active durations (seconds) — update these to change how long
	 * each timeline step stays active before advancing.
	 */
	const desktopStepDuration = 2.25;
	const mobileStepDuration = 1.75;

	/**
	 * Resolve the active-step duration in milliseconds for the current viewport.
	 *
	 * @return {number} Duration in milliseconds.
	 */
	function getStepDurationMs() {
		const isDesktop = window.matchMedia(
			`(min-width: ${ DESKTOP_MIN_WIDTH }px)`
		).matches;

		const durationSeconds = isDesktop
			? desktopStepDuration
			: mobileStepDuration;

		return durationSeconds * 1000;
	}

	/**
	 * Initialize timeline animation for a single block instance.
	 *
	 * @param {HTMLElement} section Block root element.
	 */
	function initTimelineBlock( section ) {
		const timeline = section.querySelector( '[data-timeline-root]' );

		if ( ! timeline ) {
			return;
		}

		const steps = timeline.querySelectorAll( '[data-timeline-step]' );

		if ( ! steps.length ) {
			return;
		}

		const prefersReducedMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;

		let activeIndex = 0;
		let intervalId = null;
		let animationStarted = false;

		/**
		 * Set the active step by index.
		 *
		 * @param {number} index Step index.
		 */
		function setActiveStep( index ) {
			activeIndex = index;

			steps.forEach( ( step, stepIndex ) => {
				step.classList.toggle( 'is-active', stepIndex === index );
			} );
		}

		/**
		 * Advance to the next step in the loop.
		 */
		function advanceStep() {
			const nextIndex = ( activeIndex + 1 ) % steps.length;
			setActiveStep( nextIndex );
		}

		/**
		 * Start the auto-cycle interval (once per block instance).
		 */
		function startLoop() {
			if ( animationStarted ) {
				return;
			}

			animationStarted = true;

			if ( prefersReducedMotion || steps.length <= 1 ) {
				setActiveStep( 0 );
				return;
			}

			intervalId = window.setInterval( advanceStep, getStepDurationMs() );
		}

		setActiveStep( 0 );

		if ( 'IntersectionObserver' in window ) {
			const visibilityObserver = new IntersectionObserver(
				( entries ) => {
					entries.forEach( ( entry ) => {
						if ( animationStarted ) {
							return;
						}

						if (
							entry.isIntersecting &&
							entry.intersectionRatio >= VISIBILITY_THRESHOLD
						) {
							startLoop();
							visibilityObserver.disconnect();
						}
					} );
				},
				{ threshold: VISIBILITY_THRESHOLD }
			);

			visibilityObserver.observe( section );
		} else {
			startLoop();
		}
	}

	/**
	 * Initialize all block instances on the page.
	 */
	function initAllTimelineBlocks() {
		document
			.querySelectorAll( BLOCK_SELECTOR )
			.forEach( initTimelineBlock );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initAllTimelineBlocks );
	} else {
		initAllTimelineBlocks();
	}
} )();
